<template>
  <header class="Header">
    <div class="Header__inner">
      <div class="Header_menu__logo">
        <img
          alt="Logo"
          class="Header_menu__logo_img"
          src="assets/img/melon_logo_blue.png"
        >
      </div>
    </div>
  </header>
</template>

<script>

export default {
}

</script>
